import axios from 'axios';
import apiEndpoints from 'app/constants/apiEndpoints';
import { createEntityAdapter, createSlice, createAsyncThunk } from '@reduxjs/toolkit';

const { CLOSING_EVENTS_PAYSTUBS } = apiEndpoints;

export const getPayStubs = createAsyncThunk('paystubs/getPayStubs', async params => {
  const axiosParams = params && params.query ? { params: { ...params.query } } : null;
  const response = await axios.get(CLOSING_EVENTS_PAYSTUBS, axiosParams);
  const data = response.data.data.paystubs;
  const mapped = data.map(o => ({
    ...o,
    id: o.payments._id,
    eventId: o.id
  }));
  return mapped;
});

const paystubsAdapter = createEntityAdapter({});

export const {
  selectAll: selectPayStubs,
  selectIds: selectPayStubsIds,
  selectById: selectPayStubById
} = paystubsAdapter.getSelectors(state => state.payrollPage.paystubs);

const initialState = paystubsAdapter.getInitialState({});

const paystubsSlice = createSlice({
  name: 'paystubs/events',
  initialState,
  reducers: {
    clearEvents: () => initialState
  },
  extraReducers: {
    [getPayStubs.fulfilled]: paystubsAdapter.setAll
  }
});

export const { clearEvents } = paystubsSlice.actions;

export default paystubsSlice.reducer;
